const MapeoDeIds = {
  'I': 'Inicial',
  'F': 'Final',
  'R': 'Recurso Corte',
  'J': 'Junta Médica',
  'A': 'Impugnación/Asistencia Pericia',
  'P': 'Puntos Pericia',
  'E': 'Envío documental',
  'G': 'Impugnación pericia',
  'N': 'Nueva demanda',
  'T': 'Perito responde',
};

// Método para obtener el valor de cadena a partir del id
function obtenerValorEtapa(estado) {
  const valorString = MapeoDeIds[estado];
  if (valorString === undefined) {
    return 'X';
  }
  return valorString;
}

export { obtenerValorEtapa }